"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _styles = require("../styles");

var _module = require("../module");

var _reduceBreakpoints = require("../module/reduce-breakpoints");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Grid = function Grid(_ref) {
  var cells = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$isContainer = _ref.isContainer,
      isContainer = _ref$isContainer === void 0 ? false : _ref$isContainer,
      margin = _ref.margin,
      padding = _ref.padding,
      styled = _ref.styled,
      classNames = _ref.classNames,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      xs = _ref.xs,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;

  var _useMemo = (0, _react.useMemo)(function () {
    return {
      divisions: (0, _module.countDivisions)(cells),
      cellsSizes: (0, _module.countCellsSizes)(cells),
      cellsCount: (0, _module.countCells)(cells),
      offsets: (0, _module.countOffsets)(cells)
    };
  }, [cells]),
      divisions = _useMemo.divisions,
      cellsSizes = _useMemo.cellsSizes,
      cellsCount = _useMemo.cellsCount,
      offsets = _useMemo.offsets;

  return /*#__PURE__*/_react["default"].createElement(_styles.Styled.Grid, {
    as: as,
    divisions: divisions,
    isContainer: isContainer,
    cellsCount: cellsCount,
    breakpoints: {
      xs: xs,
      md: md,
      lg: lg,
      xl: xl
    },
    $margin: margin,
    $padding: padding,
    $styled: styled,
    $classNames: classNames,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_module.GridContext.Provider, {
    value: {
      cellsSizes: cellsSizes,
      gridBreakpoints: {
        xs: xs,
        md: md,
        lg: lg,
        xl: xl
      },
      offsets: offsets
    }
  }, (0, _module.mapCells)(cells)));
};

Grid.displayName = 'Grid';

var cellsValidator = function cellsValidator(props, propName, componentName) {
  var cells = props[propName];

  var validateCell = function validateCell(cell) {
    if ((0, _module.validateChild)(cell)) {
      var _cell$type, _cell$type2, _cell$type2$target;

      throw new Error("Invalid prop \"".concat(propName, "\" passed to \"").concat(componentName, "\". Expected Cell component as children but received - \"").concat(((_cell$type = cell.type) === null || _cell$type === void 0 ? void 0 : _cell$type.name) || (cell === null || cell === void 0 ? void 0 : (_cell$type2 = cell.type) === null || _cell$type2 === void 0 ? void 0 : (_cell$type2$target = _cell$type2.target) === null || _cell$type2$target === void 0 ? void 0 : _cell$type2$target.name), "\"."));
    }
  };

  try {
    if (Array.isArray(cells)) {
      cells.forEach(function (cell) {
        if (Array.isArray(cell)) {
          cell.forEach(validateCell);
        } else {
          validateCell(cell);
        }
      });
    } else {
      validateCell(cells);
    }
  } catch (error) {
    return error;
  }
};

Grid.propTypes = _objectSpread({
  children: cellsValidator,
  as: _utils.common.wrapperTag,
  isContainer: _propTypes["default"].bool,
  margin: (0, _utils.indentProps)(),
  padding: (0, _utils.indentProps)()
}, (0, _reduceBreakpoints.reduceBreakpointsToObject)(function (breakpoint) {
  return _defineProperty({}, breakpoint, _propTypes["default"].exact({
    template: _propTypes["default"].string,
    maxWidth: _propTypes["default"].number,
    direction: _utils.common.direction,
    gap: _propTypes["default"].number,
    alignment: _utils.common.alignment
  }));
}), {}, (0, _utils.classNames)(['Grid']));
Grid.defaultProps = {
  as: 'div',
  isContainer: false
};
var _default = Grid;
exports["default"] = _default;